<template>
 
<div>
    <b-row>
    <b-col>
        <img v-if="qrData.qrcode !== ''" style="width: 100%; height: 100%;" :src="`data:image/jpeg;base64, ${qrData.qrcode}`">
    </b-col>
  
  
    </b-row >


    <b-row class="mt-4"  align="center">
    <b-col v-if="qrData.qrcode !== ''"  align-self="center">
        <div @click="$router.push({ path: `payment`,
         query: {
          aid: $route.params.aid,
          type: $route.params.type,
          pid: $route.params.pid,
          at: $route.params.at,
        }})" style="width: 280px; height: 35px; background-color: #68C191; border-radius: 20px; align-self: center !important;">
          <label style="color: white; margin-top: 5px;">กลับ</label>
        </div>
    </b-col>
   
  </b-row>

</div>


</template>

<script>


import axios from 'axios'
export default {
  name: 'qrpromptpay',
  components: {
    // CardForm
  },
  data () {
    return {
        qrData: {
            tokenId: '',
            qrcode: ''
        },
        polling: null
    }
  },
  beforeDestroy(){
        this.$loading(false)
clearInterval(this.polling)
  },
  mounted(){
this.getQrPromptpay()
  },
   methods: {
           async getQrPromptpay(){
             this.$loading(true)

        var paymentTypeSet = 'Promptpay'
        var packageId = ''

 
        if (this.$route.params.type === 'Plus')
            packageId = this.$route.params.type
        else if (this.$route.params.type === 'Farm')
            packageId = this.$route.params.type
        else
        {
          this.$loading(false)

            window.location.href = 'https://fahfon.info'
            return;
        }


        var transectionbody = {
            token: 'Promptpay',
            payload: {},
                audience: '0jSRCeScRxUkZxUnIzB4/crAWrjlMsQ62T6FpPoy9x5iv9ualMDYtg=='
                }

                var resultPayment =    await axios({
                method: "post",
                processData: true,
                // contentType: "text/plain",
                cache: false,
                url: `https://api.fahfon.info/api/Accounts/${this.$route.params.aid}/payments/${paymentTypeSet}/packages/${this.$route.params.pid}`,
                data: transectionbody,
                headers: {
                  'Accept': '*/*',
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.$route.params.at}` 
                }
              })

              this.$loading(false)


              if (resultPayment.status === 201) {
             

                    this.qrData = resultPayment.data

var vm = this

 this.polling = setInterval(() => {
     vm.checkPayQrPayment()
     
     }, 5000);
              
                 
              }
              

     },

         async checkPayQrPayment() {
    

        var body = {
            token: this.qrData.tokenId,
            audience: '0jSRCeScRxUkZxUnIzB4/crAWrjlMsQ62T6FpPoy9x5iv9ualMDYtg=='
        }

            var resultCheck =    await axios({
                method: "post",
                processData: true,
                // contentType: "text/plain",
                cache: false,
                url: `https://api.fahfon.info/api/Accounts/${this.$route.params.aid}/transection/payment`,
                data: body,
                headers: {
                  'Accept': '*/*',
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${this.$route.params.at}` 
                }
              })

              if (resultCheck.status === 201) {
             

                window.location.href = `fahfon://app/payment/${this.qrData.tokenId}/account/${this.$route.params.aid}/creditverify`

              }
  
    }

   }

}
</script>

<style lang="scss">
</style>
